// constants/chainQuestions.js
// アンサーチェーン用の問題データ

/**
 * 問題フォーマット:
 * {
 *   id: string,                    // ユニークID
 *   category: string,              // カテゴリ
 *   difficulty: number,            // 難易度 1-5
 *   answerCount: number,           // 必要回答数 (5 or 10)
 *   prompt: string,                // 問題文
 *   answers: [                     // 正解リスト（必要数より多く登録可能）
 *     { text: string, reading: string }
 *   ]
 * }
 */

export const CHAIN_QUESTIONS = [
  // ===== 5問版 =====
  {
    id: 'chain5-1-001',
    category: 'ペット',
    difficulty: 1,
    answerCount: 5,
    prompt: '家で飼えるペットを5つ答えろ！',
    answers: [
      { text: '犬', reading: 'いぬ' },
      { text: '猫', reading: 'ねこ' },
      { text: 'うさぎ', reading: 'うさぎ' },
      { text: 'ハムスター', reading: 'はむすたー' },
      { text: '金魚', reading: 'きんぎょ' },
      { text: 'インコ', reading: 'いんこ' },
      { text: '亀', reading: 'かめ' },
      { text: 'フェレット', reading: 'ふぇれっと' },
      { text: 'モルモット', reading: 'もるもっと' },
      { text: 'メダカ', reading: 'めだか' },
      { text: '文鳥', reading: 'ぶんちょう' },
      { text: 'チンチラ', reading: 'ちんちら' },
      { text: 'ハリネズミ', reading: 'はりねずみ' },
      { text: 'リス', reading: 'りす' },
      { text: 'カブトムシ', reading: 'かぶとむし' },
    ],
  },
  {
    id: 'chain5-1-002',
    category: '食べ物',
    difficulty: 1,
    answerCount: 5,
    prompt: 'ファストフード店のメニューを5つ答えろ！',
    answers: [
      { text: 'ハンバーガー', reading: 'はんばーがー' },
      { text: 'ポテト', reading: 'ぽてと' },
      { text: 'ナゲット', reading: 'なげっと' },
      { text: 'シェイク', reading: 'しぇいく' },
      { text: 'コーラ', reading: 'こーら' },
      { text: 'チキン', reading: 'ちきん' },
      { text: 'サラダ', reading: 'さらだ' },
      { text: 'アイス', reading: 'あいす' },
      { text: 'コーヒー', reading: 'こーひー' },
      { text: 'ホットドッグ', reading: 'ほっとどっぐ' },
      { text: 'パイ', reading: 'ぱい' },
      { text: 'オニオンリング', reading: 'おにおんりんぐ' },
    ],
  },
  {
    id: 'chain5-1-003',
    category: 'スポーツ',
    difficulty: 1,
    answerCount: 5,
    prompt: '球技を5つ答えろ！',
    answers: [
      { text: 'サッカー', reading: 'さっかー' },
      { text: '野球', reading: 'やきゅう' },
      { text: 'バスケットボール', reading: 'ばすけっとぼーる' },
      { text: 'テニス', reading: 'てにす' },
      { text: 'バレーボール', reading: 'ばれーぼーる' },
      { text: 'ゴルフ', reading: 'ごるふ' },
      { text: 'ラグビー', reading: 'らぐびー' },
      { text: '卓球', reading: 'たっきゅう' },
      { text: 'バドミントン', reading: 'ばどみんとん' },
      { text: 'ボウリング', reading: 'ぼうりんぐ' },
      { text: 'ハンドボール', reading: 'はんどぼーる' },
      { text: 'ソフトボール', reading: 'そふとぼーる' },
    ],
  },
  {
    id: 'chain5-2-001',
    category: '地理',
    difficulty: 2,
    answerCount: 5,
    prompt: 'ヨーロッパの国を5つ答えろ！',
    answers: [
      { text: 'フランス', reading: 'ふらんす' },
      { text: 'ドイツ', reading: 'どいつ' },
      { text: 'イタリア', reading: 'いたりあ' },
      { text: 'スペイン', reading: 'すぺいん' },
      { text: 'イギリス', reading: 'いぎりす' },
      { text: 'オランダ', reading: 'おらんだ' },
      { text: 'ベルギー', reading: 'べるぎー' },
      { text: 'スイス', reading: 'すいす' },
      { text: 'ポルトガル', reading: 'ぽるとがる' },
      { text: 'ギリシャ', reading: 'ぎりしゃ' },
      { text: 'オーストリア', reading: 'おーすとりあ' },
      { text: 'スウェーデン', reading: 'すうぇーでん' },
      { text: 'ノルウェー', reading: 'のるうぇー' },
      { text: 'デンマーク', reading: 'でんまーく' },
      { text: 'フィンランド', reading: 'ふぃんらんど' },
    ],
  },
  {
    id: 'chain5-2-002',
    category: '色',
    difficulty: 2,
    answerCount: 5,
    prompt: '虹の色を5つ答えろ！',
    answers: [
      { text: '赤', reading: 'あか' },
      { text: '橙', reading: 'だいだい' },
      { text: '黄', reading: 'き' },
      { text: '緑', reading: 'みどり' },
      { text: '青', reading: 'あお' },
      { text: '藍', reading: 'あい' },
      { text: '紫', reading: 'むらさき' },
      { text: 'オレンジ', reading: 'おれんじ' },
      { text: 'きいろ', reading: 'きいろ' },
    ],
  },
  {
    id: 'chain5-3-001',
    category: '歴史',
    difficulty: 3,
    answerCount: 5,
    prompt: '徳川将軍の名前を5人答えろ！',
    answers: [
      { text: '家康', reading: 'いえやす' },
      { text: '秀忠', reading: 'ひでただ' },
      { text: '家光', reading: 'いえみつ' },
      { text: '家綱', reading: 'いえつな' },
      { text: '綱吉', reading: 'つなよし' },
      { text: '家宣', reading: 'いえのぶ' },
      { text: '家継', reading: 'いえつぐ' },
      { text: '吉宗', reading: 'よしむね' },
      { text: '家重', reading: 'いえしげ' },
      { text: '家治', reading: 'いえはる' },
      { text: '家斉', reading: 'いえなり' },
      { text: '家慶', reading: 'いえよし' },
      { text: '家定', reading: 'いえさだ' },
      { text: '家茂', reading: 'いえもち' },
      { text: '慶喜', reading: 'よしのぶ' },
    ],
  },

  // ===== 10問版 =====
  {
    id: 'chain10-1-001',
    category: '都道府県',
    difficulty: 1,
    answerCount: 10,
    prompt: '日本の都道府県を10個答えろ！',
    answers: [
      { text: '東京', reading: 'とうきょう' },
      { text: '大阪', reading: 'おおさか' },
      { text: '北海道', reading: 'ほっかいどう' },
      { text: '沖縄', reading: 'おきなわ' },
      { text: '京都', reading: 'きょうと' },
      { text: '福岡', reading: 'ふくおか' },
      { text: '愛知', reading: 'あいち' },
      { text: '神奈川', reading: 'かながわ' },
      { text: '千葉', reading: 'ちば' },
      { text: '埼玉', reading: 'さいたま' },
      { text: '兵庫', reading: 'ひょうご' },
      { text: '広島', reading: 'ひろしま' },
      { text: '宮城', reading: 'みやぎ' },
      { text: '新潟', reading: 'にいがた' },
      { text: '静岡', reading: 'しずおか' },
      { text: '長野', reading: 'ながの' },
      { text: '岡山', reading: 'おかやま' },
      { text: '熊本', reading: 'くまもと' },
      { text: '鹿児島', reading: 'かごしま' },
      { text: '石川', reading: 'いしかわ' },
      { text: '富山', reading: 'とやま' },
      { text: '岐阜', reading: 'ぎふ' },
      { text: '三重', reading: 'みえ' },
      { text: '滋賀', reading: 'しが' },
      { text: '奈良', reading: 'なら' },
      { text: '和歌山', reading: 'わかやま' },
      { text: '鳥取', reading: 'とっとり' },
      { text: '島根', reading: 'しまね' },
      { text: '山口', reading: 'やまぐち' },
      { text: '香川', reading: 'かがわ' },
      { text: '愛媛', reading: 'えひめ' },
      { text: '高知', reading: 'こうち' },
      { text: '徳島', reading: 'とくしま' },
      { text: '佐賀', reading: 'さが' },
      { text: '長崎', reading: 'ながさき' },
      { text: '大分', reading: 'おおいた' },
      { text: '宮崎', reading: 'みやざき' },
      { text: '山形', reading: 'やまがた' },
      { text: '秋田', reading: 'あきた' },
      { text: '岩手', reading: 'いわて' },
      { text: '青森', reading: 'あおもり' },
      { text: '福島', reading: 'ふくしま' },
      { text: '山梨', reading: 'やまなし' },
      { text: '群馬', reading: 'ぐんま' },
      { text: '栃木', reading: 'とちぎ' },
      { text: '茨城', reading: 'いばらき' },
      { text: '福井', reading: 'ふくい' },
    ],
  },
  {
    id: 'chain10-2-001',
    category: '食べ物',
    difficulty: 2,
    answerCount: 10,
    prompt: '寿司ネタを10種類答えろ！',
    answers: [
      { text: 'まぐろ', reading: 'まぐろ' },
      { text: 'サーモン', reading: 'さーもん' },
      { text: 'いくら', reading: 'いくら' },
      { text: 'うに', reading: 'うに' },
      { text: 'えび', reading: 'えび' },
      { text: 'たまご', reading: 'たまご' },
      { text: 'いか', reading: 'いか' },
      { text: 'たこ', reading: 'たこ' },
      { text: 'あなご', reading: 'あなご' },
      { text: 'ほたて', reading: 'ほたて' },
      { text: 'はまち', reading: 'はまち' },
      { text: 'ぶり', reading: 'ぶり' },
      { text: 'あじ', reading: 'あじ' },
      { text: 'さば', reading: 'さば' },
      { text: 'ひらめ', reading: 'ひらめ' },
      { text: 'たい', reading: 'たい' },
      { text: 'かんぱち', reading: 'かんぱち' },
      { text: 'えんがわ', reading: 'えんがわ' },
      { text: 'ねぎとろ', reading: 'ねぎとろ' },
      { text: '中トロ', reading: 'ちゅうとろ' },
      { text: '大トロ', reading: 'おおとろ' },
      { text: 'かつお', reading: 'かつお' },
      { text: 'さんま', reading: 'さんま' },
      { text: 'いわし', reading: 'いわし' },
      { text: 'あわび', reading: 'あわび' },
      { text: 'かに', reading: 'かに' },
    ],
  },
  {
    id: 'chain10-3-001',
    category: '芸能',
    difficulty: 3,
    answerCount: 10,
    prompt: '嵐のシングル曲を10曲答えろ！',
    answers: [
      { text: 'A・RA・SHI', reading: 'あらし' },
      { text: 'Love so sweet', reading: 'らぶそーすいーと' },
      { text: 'Happiness', reading: 'はっぴねす' },
      { text: 'truth', reading: 'とぅるーす' },
      { text: 'Monster', reading: 'もんすたー' },
      { text: 'Believe', reading: 'びりーぶ' },
      { text: 'One Love', reading: 'わんらぶ' },
      { text: '明日の記憶', reading: 'あしたのきおく' },
      { text: 'Beautiful days', reading: 'びゅーてぃふるでいず' },
      { text: 'Troublemaker', reading: 'とらぶるめーかー' },
      { text: 'サクラ咲ケ', reading: 'さくらさけ' },
      { text: 'きっと大丈夫', reading: 'きっとだいじょうぶ' },
      { text: 'Wish', reading: 'うぃっしゅ' },
      { text: 'GUTS!', reading: 'がっつ' },
      { text: '青空の下、キミのとなり', reading: 'あおぞらのしたきみのとなり' },
    ],
  },
];

/**
 * 問題をランダムに1つ選択
 * @param {number} answerCount - 5 or 10
 * @param {number} difficulty - 難易度 1-5
 * @param {string[]} excludeIds - 除外するID
 * @returns {Object|null}
 */
export function pickRandomChainQuestion(answerCount, difficulty, excludeIds = []) {
  const candidates = CHAIN_QUESTIONS.filter(
    q => q.answerCount === answerCount &&
         q.difficulty === difficulty &&
         !excludeIds.includes(q.id)
  );

  if (candidates.length === 0) {
    // フォールバック: 難易度を無視
    const fallback = CHAIN_QUESTIONS.filter(
      q => q.answerCount === answerCount && !excludeIds.includes(q.id)
    );
    if (fallback.length === 0) return null;
    return fallback[Math.floor(Math.random() * fallback.length)];
  }

  return candidates[Math.floor(Math.random() * candidates.length)];
}

/**
 * 全問題を取得
 */
export function getAllChainQuestions() {
  return CHAIN_QUESTIONS;
}
